<article class="campaign-card">
  <div class="campaign-card-kicker">Campaign</div>
  <h3>{{ campaign().name || 'Unnamed Campaign' }}</h3>
  <p>{{ campaign().description || 'No description was provided for this campaign.' }}</p>

  <div class="campaign-card-meta">
    <strong>Universe:</strong>
    <span>{{ universeName() || 'Unknown Universe' }}</span>
  </div>
</article>
